import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
  children: React.ReactNode;
}

/**
 * Component that handles page transitions with military-themed animations
 */
const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [displayChildren, setDisplayChildren] = useState(children);
  const location = useLocation();

  useEffect(() => {
    // Start transition out
    setIsTransitioning(true);
    
    // After transition out completes, update children and transition in
    const timer = setTimeout(() => {
      setDisplayChildren(children);
      setIsTransitioning(false);
    }, 300);

    return () => clearTimeout(timer);
  }, [location.pathname, children]);

  return (
    <div className={`transition-all duration-300 ${
      isTransitioning 
        ? 'opacity-0 translate-y-4 scale-95' 
        : 'opacity-100 translate-y-0 scale-100'
    }`}>
      {displayChildren}
    </div>
  );
};

export default PageTransition;


